export const applyTeamTheme = (team = {}) => {
  if (typeof document === "undefined") return;

  const themeColor = team.themeColor || "#330055";
  document.documentElement.style.setProperty("--theme-color", themeColor);
  document.documentElement.style.setProperty("--teamColor", themeColor);
  document.documentElement.style.setProperty("--theme-hover-color", team.hoverColor || "#2a2a2a");
  document.documentElement.style.setProperty("--theme-text-color", team.textColor || "#fff");
  document.documentElement.style.setProperty("--team-special-color", team.specialColor || "#ff691e");
};
